import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import Pagination from "react-js-pagination";
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import ProductsUpload from '../../Models/ProductsUpload';
import Affiliator from '../../Models/Affiliator';
class AffiliatorLotteryBonus extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('0'))
            this.props.history.push('/login/affiliator');
        };
        this.state = {
            _id: false,
            activePage: 1,
            categories: [],
            affiliatorCommission: [],
            seller_name: '',
            category: '',
            affCommission: '',
            affilitedProducts: [],
            user: x
        };
        this.getLotteryBonus();
        // this.getAffiliatorCommission();
    }
    componentDidMount() {

        window.scrollTo(0, 0)

    }
    getLotteryBonus() {
        let x = JSON.parse(localStorage.getItem('info'));
        Affiliator.getLotteryBonus(x.id).then(res => {
            console.log(res.data)
            this.setState({ affilitedProducts: res.data.payload })
        })
    }
    // getCategories() {
    //     ProductsUpload.getCategoryDropdown().then(res => {
    //         this.setState({ categories: res.data.categories })
    //     })
    // }
    // getAffiliatorCommission() {
    //     ProductsUpload.getCategory().then(res => {
    //         this.setState({ affiliatorCommission: res.data.aff_points })
    //     })
    // }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    handleSubmit(e) {
        e.preventDefault()
        let data = {
            seller_name: this.state.seller_name,
            category_id: this.refs.category.value,
            commission_level: this.refs.affCommission.value,
            aff_id: this.state.user.id
        }
        // if () {
        //     alert("please seclect atleast one category")
        // } else {
        Affiliator.getAffiliatedProducts(data).then(res => {
            // alert('Please Select atleast one category')
            if (res.data.status === 200) {
                this.setState({ affilitedProducts: res.data.payload })
            }
        })
        // }
    }
    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
    }
    render() {
        let x = JSON.parse(localStorage.getItem('info'));
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    <AffiliatorSidebar />
                                </div>
                                <div className="col-md-8">
                                    <div className="mt-5 mb-3 input_name big_font guide_text" style={{width: "100%"}}>
                                        {this.props.t('3')}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 pt-1">
                                            <div></div>
                                            <select className="catagory_select" ref="category">
                                                <option value="">  {this.props.t('1')}</option>
                                                <option value="1"> {this.props.t('5')}</option>
                                                <option value="2"> {this.props.t('6')}</option>
                                                <option value="3"> {this.props.t('7')}</option>
                                                <option value="4"> {this.props.t('8')}</option>
                                                <option value="5"> {this.props.t('9')}</option>
                                                <option value="6"> {this.props.t('10')}</option>
                                                <option value="7"> {this.props.t('11')}</option>
                                                <option value="8"> {this.props.t('12')}</option>
                                                <option value="9"> {this.props.t('13')}</option>
                                                <option value="10"> {this.props.t('14')}</option>
                                                <option value="11"> {this.props.t('15')}</option>
                                                <option value="12"> {this.props.t('16')}</option>

                                            </select>
                                        </div>
                                        {/* <div className="col-md-1">
                                            <i className="fa fa-angle-right"></i>
                                        </div> */}

                                        <div className="col-md-3 pt-1">
                                            <div></div>
                                            <select className="catagory_select " ref="affCommission" >
                                                <option value="">{this.props.t('18')}</option>
                                                {/* {this.state.affiliatorCommission.map(rp =>
                                                    <option value={rp.id} key={rp.id}>
                                                        {rp.point_value}%
                                                    </option>
                                                )} */}
                                            </select>
                                        </div>
                                        <div className="col-md-2  ">
                                            <button type="submit" className="btn btn-success" onClick={this.handleSubmit.bind(this)}
                                            style={{width:'100%', backgroundColor: "#7ea9e6",borderColor: "#6290d1",height:'35px',borderRadius:'5px',color:'#fff',boxShadow:"#ffffff4d 0px 1px 0px 0px inset" }}>
                                            {this.props.t('4')}
                                            </button>
                                        </div>
                                    </div>
                                    <table className="table_individual mt-3">
                                        <tbody>
                                            <tr >

                                                <td style={{ width: '40%' }}>
                                                    {this.props.t('2')}
                                                </td>
                                                <td style={{ width: '30%' }}>
                                                    {this.props.t('5')}
                                                </td>
                                                <td style={{ width: '30%' }}>
                                                    {this.props.t('17')}
                                                </td>

                                            </tr>
                                            {this.state.affilitedProducts.map(affi =>
                                                <tr >

                                                    <td style={{ width: '50%' }}>
                                                        {affi.title}
                                                    </td>
                                                    <td style={{ width: '30%' }}>
                                                        {parseInt(affi.price)}
                                                    </td>
                                                    <td style={{ width: '30%' }}>
                                                        {parseInt(affi.affiliator_commission_amount)}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    {/* <div className="row">
                                        <div className="col-md-2"></div>
                                        <div className="col-md-8 ml-5 mt-4">
                                            <Pagination
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={10}
                                                totalItemsCount={450}
                                                pageRangeDisplayed={5}
                                                onChange={this.handlePageChange.bind(this)}
                                            />
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export { AffiliatorLotteryBonus }


 AffiliatorLotteryBonus = withTranslation('src_Components_Affiliator_AffiliatorLotteryBonus')(AffiliatorLotteryBonus);
